// 公共常量

// 可用语言
export const AVAILABLE_LANGUAGES = ['zh-CN', 'en-US'];

// 默认语言
export const DEFAULT_LANGUAGE = AVAILABLE_LANGUAGES[0];

export const COOKIE_DOMAIN_ATOMGIT = '.atomgit.com';

// Cookie 当前语言 Key
export const COOKIE_KEY_LANGUAGE = 'DEFAULT_LANG';

// Token Key
export const COOKIE_KEY_TOKEN = 'atomgit_pop_api_token';

// AtomGit 那边的 Cookie Key
export const COOKIE_KEY_ATOMGIT_USER = 'atom_user';

export const COOKIE_KEY_ATOMGIT_ACCESS_TOKEN = 'ATOMGIT_ACCESS_TOKEN';

export const HEADER_KEY_COMMUNITY = 'X-ATOMGIT-POP-COMMUNITY';
export const HEADER_KEY_LANGUAGE = 'X-ATOMGIT-POP-LANGUAGE';
export const HEADER_KEY_TOKEN = 'X-ATOMGIT-POP-TOKEN';

export const STORAGE_KEY_STATS = 'atomgit_pop_stats';
export const STORAGE_KEY_HOME_POPUP = 'atomgit_pop_home_popup';
